var _circle, _g, _g2, _circle2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcBuy4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 72,
    viewBox: "0 0 74 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 36,
    r: 36,
    fill: "#13AE67",
    fillOpacity: 0.08
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4551_75641)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 44L20 47",
    stroke: "white",
    strokeOpacity: 0.61,
    strokeWidth: 1.77417,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 44L55 47",
    stroke: "white",
    strokeOpacity: 0.61,
    strokeWidth: 1.77417,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_4551_75641)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 17,
    width: 44,
    height: 28,
    rx: 4,
    fill: "white",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.8871,
    y: 17.8871,
    width: 42.2258,
    height: 26.2258,
    rx: 3.11292,
    stroke: "url(#paint0_linear_4551_75641)",
    strokeWidth: 1.77417
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_4551_75641)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 25,
    width: 16,
    height: 30,
    rx: 4,
    fill: "white",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.7863,
    y: 25.7863,
    width: 14.4274,
    height: 28.4274,
    rx: 3.21372,
    stroke: "url(#paint1_linear_4551_75641)",
    strokeWidth: 1.57256
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 48,
    r: 3,
    stroke: "url(#paint2_linear_4551_75641)",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 33,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#D9D9D9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 29,
    width: 4,
    height: 2,
    rx: 1,
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 36,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 39,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#D9D9D9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 33,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#D9D9D9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 36,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#D9D9D9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 39,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#D9D9D9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 33,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#D9D9D9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 36,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#D9D9D9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 39,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.0385 29.2724C39.3615 30.0442 39.3615 31.9558 38.0385 32.7276L32.0077 36.2455C30.6744 37.0233 29 36.0615 29 34.5179L29 27.4821C29 25.9385 30.6744 24.9767 32.0077 25.7545L38.0385 29.2724Z",
    fill: "url(#paint3_linear_4551_75641)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4551_75641",
    x: 0.806658,
    y: 6.35499,
    width: 72.3867,
    height: 59.2734,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.54834
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.09667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4551_75641"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4551_75641",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_4551_75641",
    x: 11.4517,
    y: 13.4517,
    width: 51.0967,
    height: 35.0967,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.77417
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_4551_75641"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_4551_75641",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_4551_75641",
    x: 41.8549,
    y: 21.8549,
    width: 22.2902,
    height: 36.2902,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.57256
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_4551_75641"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_4551_75641",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4551_75641",
    x1: 17.9441,
    y1: 17,
    x2: 59.4551,
    y2: 44.3083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4551_75641",
    x1: 46.0706,
    y1: 25,
    x2: 66.6712,
    y2: 29.5996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4551_75641",
    x1: 50.289,
    y1: 45.163,
    x2: 56.2107,
    y2: 51.1718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F1F1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4551_75641",
    x1: 29,
    y1: 24,
    x2: 38.86,
    y2: 35.7668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBuy4);
export default __webpack_public_path__ + "static/media/ic-buy4.50cf4e083278343c79f8da404b1a4998.svg";
export { ForwardRef as ReactComponent };